import React from "react";
import { mergeDeep } from "../../../../utils/Helper";

export const Dispatch = React.createContext(null);

export const initialize = (props) => {
  return (initialState) => {
    return mergeDeep(
      { ...initialState },
      {
        alertEv: parseAlert(props.alert),
      }
    );
  };
};

export const defaultState = () => ({
  ui: {
    loadings: {
      alert: true,
    },
    childAlert: {
      open: false,
      alert: {},
    },
  },
  alertEv: {
    title: "",
    description: "",
    date: new Date(),
    trigger: "",
    accountsRelated: [],
    antiClientDetails: [],
    personInfo: {},
    lastDayIncreaseDate: null,
  },
  addedData: {
    description: null,
  },
  fields: {
    readonly: {},
    errors: {},
  },
  hasLockDate: false,
  lockDate: new Date(),
  loadingUpdateDate: false,
  messageDisplay: false,
});

export function parseAlert(alert) {
  return {
    ...alert,
  };
}
